(function() {
  'use strict';

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function showRecoverMessage(type, message, config) {
    // Remove existing messages
    const existingMessages = document.querySelectorAll('.recover-message');
    existingMessages.forEach(msg => msg.remove());
    
    // Create new message
    const messageDiv = document.createElement('div');
    messageDiv.className = `recover-message form-${type}`;
    
    if (type === 'success') {
      messageDiv.style.backgroundColor = config.successBg || '#DDFEE9';
      messageDiv.style.color = config.successColor || '#1FA653';
      messageDiv.innerHTML = `
        <div class="success-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2"/>
            <path d="M6 10L8.5 12.5L14 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span class="success-message">${message}</span>
      `;
    } else {
      messageDiv.style.backgroundColor = config.errorBg || '#FEE';
      messageDiv.style.color = config.errorColor || '#C33';
      messageDiv.innerHTML = `
        <div class="error-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2"/>
            <path d="M10 6V10M10 14H10.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span class="error-message">${message}</span>
      `;
    }
    
    // Insert message after the form title
    const formTitle = document.querySelector('#recover-form .login-title');
    if (formTitle) {
      formTitle.insertAdjacentElement('afterend', messageDiv);
    }
  }

  function initPasswordRecovery() {
    const recoverForm = document.getElementById('recover_password_form');
    const recoverSubmitBtn = document.getElementById('recover-submit-btn');
    const configElement = document.querySelector('[data-recover-config]');
    
    if (!recoverForm || !recoverSubmitBtn) {
      return;
    }

    // Get configuration from data attributes
    const config = {
      successText: configElement ? (configElement.getAttribute('data-success-text') || 'An e-mail has been sent to your address with instructions to reset your password.') : 'An e-mail has been sent to your address with instructions to reset your password.',
      submitText: configElement ? (configElement.getAttribute('data-submit-text') || 'RECOVER') : 'RECOVER',
      successBg: configElement ? (configElement.getAttribute('data-success-bg') || '#DDFEE9') : '#DDFEE9',
      successColor: configElement ? (configElement.getAttribute('data-success-color') || '#1FA653') : '#1FA653',
      errorBg: configElement ? (configElement.getAttribute('data-error-bg') || '#FEE') : '#FEE',
      errorColor: configElement ? (configElement.getAttribute('data-error-color') || '#C33') : '#C33'
    };

    recoverForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const emailInput = document.getElementById('recover_email');
      const email = emailInput.value.trim();
      
      if (!email) {
        showRecoverMessage('error', 'Please enter your email address.', config);
        return;
      }
      
      if (!isValidEmail(email)) {
        showRecoverMessage('error', 'Please enter a valid email address.', config);
        return;
      }
      
      // Show loading state
      recoverSubmitBtn.textContent = 'SENDING...';
      recoverSubmitBtn.disabled = true;
      
      const formData = new FormData(recoverForm);
      
      // Check if authenticity_token is present
      let authToken = formData.get('authenticity_token');
      
      // Try multiple ways to find the token
      if (!authToken) {
        // Method 1: Look for hidden input in form
        const tokenInput = recoverForm.querySelector('input[name="authenticity_token"]');
        if (tokenInput && tokenInput.value) {
          authToken = tokenInput.value;
          formData.set('authenticity_token', authToken);
        } else {
          // Method 2: Look for meta tag
          const metaToken = document.querySelector('meta[name="csrf-token"]');
          if (metaToken && metaToken.content) {
            authToken = metaToken.content;
            formData.set('authenticity_token', authToken);
          } else {
            // Method 3: Look in all forms on the page
            const allForms = document.querySelectorAll('form');
            for (const form of allForms) {
              const formTokenInput = form.querySelector('input[name="authenticity_token"]');
              if (formTokenInput && formTokenInput.value) {
                authToken = formTokenInput.value;
                formData.set('authenticity_token', authToken);
                break;
              }
            }
          }
        }
      }
      
      if (!authToken) {
        // If no token found, use traditional form submission
        // Create a hidden iframe to capture the response
        const iframe = document.createElement('iframe');
        iframe.name = 'recover-password-iframe';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        
        // Set form target to iframe
        recoverForm.target = 'recover-password-iframe';
        
        // Listen for iframe load
        iframe.onload = function() {
          // Wait a bit for the iframe to fully load
          setTimeout(function() {
            // Try to read the iframe content to check for errors
            let hasError = false;
            let errorMessage = '';
            
            try {
              // Access iframe content (may fail due to CORS)
              const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
              const iframeBody = iframeDoc.body;
              
              // Get full text content
              const iframeText = iframeBody.textContent || iframeBody.innerText || '';
              
              // Check if this is a Cloudflare challenge
              const cloudflareKeywords = [
                'se debe verificar tu conexión',
                'verify your connection',
                'enable javascript and cookies',
                'cloudflare',
                '_cf_chl_opt',
                'cf-browser-verification',
                'challenge-platform'
              ];
              
              const lowerText = iframeText.toLowerCase();
              const lowerHtml = iframeBody.innerHTML.toLowerCase();
              let isCloudflareChallenge = false;
              
              for (const keyword of cloudflareKeywords) {
                if (lowerText.includes(keyword) || lowerHtml.includes(keyword)) {
                  isCloudflareChallenge = true;
                  break;
                }
              }
              
              if (!isCloudflareChallenge) {
                // Check for error messages in the iframe - multiple patterns
                const errorSelectors = [
                  '.errors',
                  '.error',
                  '.form-error',
                  '.field-error',
                  '[class*="error"]',
                  '[id*="error"]',
                  '.alert-error',
                  '.notice--error',
                  '.banner--error'
                ];
                
                for (const selector of errorSelectors) {
                  const errorElements = iframeBody.querySelectorAll(selector);
                  if (errorElements.length > 0) {
                    hasError = true;
                    errorMessage = errorElements[0].textContent.trim();
                    break;
                  }
                }
                
                // Check text content for error keywords
                const errorKeywords = [
                  'not found',
                  'does not exist',
                  'not registered',
                  'invalid email',
                  'email address',
                  'no account',
                  'unable to find',
                  'could not find'
                ];
                
                for (const keyword of errorKeywords) {
                  if (lowerText.includes(keyword)) {
                    hasError = true;
                    errorMessage = 'The email address you entered is not registered.';
                    break;
                  }
                }
              }
              
              // Check URL of iframe for error indicators
              const iframeUrl = iframe.contentWindow.location.href;
              if (iframeUrl.includes('error') || iframeUrl.includes('invalid')) {
                hasError = true;
              }
              
            } catch (e) {
              // CORS error - can't read iframe content, assume success (Shopify default behavior)
            }
            
             if (hasError && errorMessage) {
               showRecoverMessage('error', errorMessage || 'The email address you entered is not registered.', config);
               
               // Reset button
               recoverSubmitBtn.textContent = config.submitText;
               recoverSubmitBtn.disabled = false;
               
               // Redirect to login page with recover hash after showing error
               setTimeout(() => {
                 window.location.href = '/account/login#recover';
               }, 2000);
               
               // Remove iframe after redirect
               setTimeout(() => {
                 iframe.remove();
                 recoverForm.target = '';
               }, 2500);
             } else {
               showRecoverMessage('success', config.successText, config);
               
               // Reset button
               recoverSubmitBtn.textContent = config.submitText;
               recoverSubmitBtn.disabled = false;
               
               // Remove iframe after a delay (no redirect on success)
               setTimeout(() => {
                 iframe.remove();
                 recoverForm.target = '';
               }, 2000);
             }
          }, 500); // Wait 500ms for iframe to fully load
        };
        
        // Submit form normally (this will work even without CSRF token in Theme Dev)
        recoverForm.submit();
        return;
      }
      
      // Use the form's action URL if available, otherwise use default
      const formAction = recoverForm.action || '/account/recover';
      
      fetch(formAction, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      })
      .then(response => {
        const statusCode = response.status || 200;
        
         // Shopify always returns 200 OK for security reasons (even if email doesn't exist)
         // Always show success message when response is successful (2xx status codes)
         if (statusCode >= 200 && statusCode < 300) {
           showRecoverMessage('success', config.successText, config);
         } else {
           // Only show error for actual server errors (4xx, 5xx)
           showRecoverMessage('error', 'There was an error sending the recovery email. Please try again.', config);
           
           // Redirect to login page with recover hash after showing error
           setTimeout(() => {
             window.location.href = '/account/login#recover';
           }, 2000);
         }
      })
      .catch(error => {
        // Even on network errors, show success (Shopify behavior for security)
        showRecoverMessage('success', config.successText, config);
      })
      .finally(() => {
        // Reset button
        recoverSubmitBtn.textContent = config.submitText;
        recoverSubmitBtn.disabled = false;
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPasswordRecovery);
  } else {
    initPasswordRecovery();
  }
})();

